import { render, staticRenderFns } from "./PhysicalSchedule.vue?vue&type=template&id=be4c3bf8&scoped=true"
import script from "./PhysicalSchedule.vue?vue&type=script&lang=js"
export * from "./PhysicalSchedule.vue?vue&type=script&lang=js"
import style0 from "./PhysicalSchedule.vue?vue&type=style&index=0&id=be4c3bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4c3bf8",
  null
  
)

export default component.exports